import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-18e12e2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sticky top-0 bg-white/50 dark:bg-gray-900/50 backdrop-blur-md lg:mb-4 mb-0 z-50" }
const _hoisted_2 = { class: "h-[60px] lg:h-[90px] max-w-[95vw] sm:max-w-[754px] xl:max-w-[1240px] w-full mx-auto flex justify-between items-center dark:shadow-gray-800" }
const _hoisted_3 = { class: "text-[#163537] dark:text-gray-200" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "size-8"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "m6.75 7.5 3 2.25-3 2.25m4.5 0h3m-9 8.25h13.5A2.25 2.25 0 0 0 21 18V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v12a2.25 2.25 0 0 0 2.25 2.25Z"
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-green-400 rounded-full size-2 animate-ping" }),
  /*#__PURE__*/_createElementVNode("div", { class: "z-50 md:text-sm text-xs font-semibold dark:text-gray-300 italic" }, " Currently open to work. ")
], -1))
const _hoisted_6 = {
  id: "nav",
  class: "hidden lg:flex justify-between items-center xl:space-x-[40px] text-[#757474] dark:text-gray-400 space-x-8 text-base font-[400] cursor-pointer"
}
const _hoisted_7 = { class: "lg:hidden flex items-center gap-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bars text-2xl" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "fixed inset-0 bg-white dark:bg-gray-900 min-h-screen flex flex-col items-center text-center justify-center overflow-y-hidden z-50"
}
const _hoisted_11 = { class: "flex flex-col justify-start gap-4 text-base font-[500px] text-gray-700 dark:text-gray-300" }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"flex justify-center pt-6 lg:hidden animate__backInUp animate__animated animate__bounce\" data-v-18e12e2e><div class=\"hover:ring-2 hover:ring-slate-400 dark:hover:ring-slate-600 hover:bg-slate-100 dark:hover:bg-slate-800 hover:scale-125 mr-4 size-8 bg-white dark:bg-gray-800 rounded-full flex justify-center items-center\" data-v-18e12e2e><a class=\"\" href=\"https://www.linkedin.com/in/ogbajeleo\" data-v-18e12e2e><i class=\"fa-brands fa-linkedin-in fa-lg text-gray-700 dark:text-gray-300\" data-v-18e12e2e></i></a></div><div class=\"hover:ring-2 hover:ring-slate-400 dark:hover:ring-slate-600 hover:bg-slate-100 dark:hover:bg-slate-800 hover:scale-125 sm:mt-[-8px] mr-4 size-8 bg-white dark:bg-gray-800 rounded-full flex justify-center items-center\" data-v-18e12e2e><a class=\"p-3\" href=\"https://github.com/ogbajeleo\" data-v-18e12e2e><i class=\"fa-brands fa-github fa-lg text-gray-700 dark:text-gray-300\" data-v-18e12e2e></i></a></div><div class=\"hover:ring-2 hover:ring-slate-400 dark:hover:ring-slate-600 hover:bg-slate-100 dark:hover:bg-slate-800 hover:scale-125 sm:mt-[-16px] mr-4 size-8 bg-white dark:bg-gray-800 rounded-full flex justify-center items-center\" data-v-18e12e2e><a class=\"p-3\" href=\"https://twitter.com/omaebije\" data-v-18e12e2e><i class=\"fa-brands fa-x-twitter fa-lg text-gray-700 dark:text-gray-300\" data-v-18e12e2e></i></a></div><div class=\"hover:ring-2 hover:ring-slate-400 dark:hover:ring-slate-600 hover:bg-slate-100 dark:hover:bg-slate-800 hover:scale-125 sm:mt-[-8px] mr-4 size-8 bg-white dark:bg-gray-800 rounded-full flex justify-center items-center\" data-v-18e12e2e><a class=\"p-3\" href=\"https://wa.me/+2349036787860\" data-v-18e12e2e><i class=\"fa-brands fa-whatsapp fa-lg text-gray-700 dark:text-gray-300\" data-v-18e12e2e></i></a></div><div class=\"hover:ring-2 hover:ring-slate-400 dark:hover:ring-slate-600 hover:bg-slate-100 dark:hover:bg-slate-800 hover:scale-125 size-8 bg-white dark:bg-gray-800 rounded-full flex justify-center items-center\" data-v-18e12e2e><a class=\"p-5\" href=\"mailto:leonardaromeh@gmail.com\" data-v-18e12e2e><i class=\"fa-regular fa-envelope fa-lg text-gray-700 dark:text-gray-300\" data-v-18e12e2e></i></a></div></div>", 1)

import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import DarkModeToggle from "./DarkModeToggle.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppNavbar',
  setup(__props) {

const route = useRoute();
const currentRoutePath = ref<string>(route.path);

// Watch for route changes
watch(route, (to, from) => {
  currentRoutePath.value = to.path;
});

const isMenuOpen = ref(false);

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};

const closeMenu = () => {
  isMenuOpen.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: "/",
          class: _normalizeClass(["nav-link", currentRoutePath.value == '/' ? 'font-bold text-black dark:text-white' : ''])
        }, {
          default: _withCtx(() => [
            _createTextVNode("Home")
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          to: "/projects",
          class: _normalizeClass(["nav-link", currentRoutePath.value == '/projects' ? 'font-bold text-black dark:text-white' : ''])
        }, {
          default: _withCtx(() => [
            _createTextVNode("Projects")
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          to: "/resume",
          class: _normalizeClass(["nav-link", currentRoutePath.value == '/resume' ? 'font-bold text-black dark:text-white' : ''])
        }, {
          default: _withCtx(() => [
            _createTextVNode("Resume")
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          to: "/contact",
          class: _normalizeClass(["nav-link", currentRoutePath.value == '/contact' ? 'font-bold text-black dark:text-white' : ''])
        }, {
          default: _withCtx(() => [
            _createTextVNode("Contact")
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(DarkModeToggle)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(DarkModeToggle),
        _createElementVNode("button", {
          onClick: toggleMenu,
          class: "focus:outline-none text-gray-700 dark:text-gray-300"
        }, _hoisted_9)
      ]),
      (isMenuOpen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("button", {
              onClick: closeMenu,
              class: "absolute top-4 right-10 text-4xl text-gray-700 dark:text-gray-300"
            }, " × "),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_router_link, {
                onClick: closeMenu,
                to: "/",
                class: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Home")
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                onClick: closeMenu,
                to: "/projects",
                class: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Projects")
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                onClick: closeMenu,
                to: "/resume",
                class: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Resume")
                ]),
                _: 1
              }),
              _createElementVNode("a", {
                onClick: closeMenu,
                href: "/contact"
              }, "Contact"),
              _hoisted_12
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})